import { dispatch, receive, mutate } from "./api.service";

const base = "/users";

export const getAllUsers = () => receive(`/${base}/`);
export const getUserProfile = () => receive(`/user/profile`);
export const getUserById = (id) => receive(`/user/profile/${id}`);

export const updateProfile = (data) => mutate(data, `/user/profile`);
export const updateUserById = (data, id) => mutate(data, `/${base}/${id}`);

export const updateUserPassword = (data) => dispatch(data, "/password/update");
export const resetUserPassword = (data) => dispatch(data, "/password/forgot");

export const deactivateUserById = (id) => dispatch(`/${base}/${id}`);
export const uploadProfileImage = (data, id) =>
  dispatch(data, `/${base}/uploads/${id}`);
